import PrincipalApi from './PrincipalApi';
export default PrincipalApi;
